import React from 'react';
import { StyleSheet, ViewStyle } from 'react-native';

import { UserAvatarIcon } from '@/assets/icons/user-avatar';
import { Box, Image } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

export const UserAvatar = ({
    avatarUrl,
    avatarContainerStyles,
    avatarStyles = {
        width: 20,
        height: 20,
    },
}: {
    avatarUrl?: string | null;
    avatarContainerStyles?: ViewStyle;
    avatarStyles?: {
        width?: number;
        height?: number;
    };
}) => {
    return (
        <Box
            width={40}
            height={40}
            backgroundColor={ds.colorToken.background.neutral.subtler}
            borderWidth={1}
            borderRadius={'r40'}
            p={'s10'}
            alignItems={'center'}
            justifyContent={'center'}
            style={[styles.avatarContainer, avatarContainerStyles]}
        >
            {avatarUrl ? (
                <Image source={{ uri: avatarUrl }} style={avatarStyles ?? styles.avatar} />
            ) : (
                <UserAvatarIcon />
            )}
        </Box>
    );
};

const styles = StyleSheet.create({
    avatar: {
        width: 20,
        height: 20,
    },
    avatarContainer: {
        borderColor: ds.colorValue.border.subtle,
    },
});
